

import {
  email,
  minLength,
  not,
  required,
  sameAs,
  helpers,
} from 'vuelidate/lib/validators';
import { ymGoalCheck } from '~/helpers/ym_helper';

const initForm = {
  phone: '',
  email: '',
  name: '',
  message: '',
};
export default {

  data() {
    return {
      isAgree: true,
      comment: false,
      id: null,
      form: {
        ...initForm,
      },
      error: {
        name: false,
        phone: false,
        email: false,
      },
    };
  },

  props: {
    isPhone: {
      type: Boolean,
      default: false,
    },
    isEmail: {
      type: Boolean,
      default: false,
    },
    isName: {
      type: Boolean,
      default: false,
    },
    isMessage: {
      type: Boolean,
      default: false,
    },
  },

  validations: function () {
    // Инициализация валидации формы
    const form = {};
    if (this.isName) {
      form.name = {
        required,
        userName: helpers.regex('name', /^(?!\p{Zs})(?!.*\p{Zs}$)[\p{L}\p{M}\p{Zs}]{2,45}$/u),
      };
    }
    if (this.isEmail) {
      form.email = {
        required: this.form.phone ? false : required,
        email,
      };
    }
    if (this.isPhone) {
      form.phone = {
        required: this.form.email ? false : required,
        minLength: minLength(15),
      };
    }
    if (this.isMessage) {
      form.message = {
        required: required,
        minLength: minLength(5),
      };
    }
    // ------------------------------

    return {
      form,
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters['loading/loading'];
    },
  },

  methods: {
    generateId() {
      this.id = Math.random();
    },

    async sendForm() {
      // Проверка на валидность формы
      this.$v.$touch();
      if (this.$v.$invalid) {
        return null;
      }

      this.$store.commit('loading/setLoading', true);

      const formNew = this.form;
      const response = await this.$api.agent.transport.post('form/send', {
        type: 'задать вопрос',
        ...formNew,
        nophone: '1',
      }).then((res) => res.data).catch((err) => ({
        error: err?.response?.data?.[0]?.message || 'Ошибка отправки',
      }));

      this.$store.commit('loading/setLoading', false);

      if (response.error) {
        this.$toast.error(response.error);

        return null;
      }

      ymGoalCheck({
        ymGoal: 'zadat_vopros_product_sent',
        ymNumber: process.env.yandexMetriks,
      });

      this.$toast.success('Заявка успешно отправлена');
      this.$v.$reset();
      this.form = { ...initForm };

      this.$store.commit('loading/setLoading', false);
    },
  },
  created() {
    this.generateId();
  },
};
